const LanguageCode = {
  en: 'en',
  fr: 'fr',
  nl: 'nl',
};

export default LanguageCode;
